import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/basic/bscUserInfo',
    selectAllPage(query){
        return http({
            url: this.baseurl+'/selectAllPage',
            method: 'post',
            params: query
        });
    },
    selectUserPage(query){
        return http({
            url: this.baseurl+'/selectUserPage',
            method: 'post',
            params: query
        });
    },
    selectById(id){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id}
        });
    },
    selectByName(query){
        return http({
            url: this.baseurl+'/selectByName',
            method: 'post',
            params: query
        });

    },


    getOrderAgent(id){
        return http({
            url: '/api/swyl/v1/dingdmain/getOrderAgent',
            method: 'post',
            params: {id:id}
        });
    },

    getByModel(entity){
        return http({
            url: this.baseurl+'/getByModel',
            method: 'post',
            params: entity,
        });
    },

    sendEmailToUser(form){
        return http({
            url: this.baseurl+'/sendEmailToUser',
            method: 'post',
            params: form
        });
    },
    bandRegion(v){
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoRegion/bandRegion',
            method: 'post',
            data: v
        });
    },
    queryRegion(usercode,usertype){
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoRegion/queryRegion',
            method: 'post',
            params: {usercode,usertype}
        });
    },
	//通过经销商ID查询经销商
	selectAgentSell(query){
		return http({
		    url: "/api/bscUserInfoAgentSell/selectByUsercode",
		    method: 'post',
		    params: query
		});
	},

    selectAgentByName(query){
        return http({
            url: "/api/bscUserInfoAgentSell/getAgentByName?customerName="+query,
            method: 'post',
        });
    },
    getAgentByCodeOne(query){
        return http({
            url: "/api/bscUserInfoAgentSell/getAgentByCodeOne?usercode="+query,
            method: 'post',
        });
    },
    selectAgentByNameFx(query){
        return http({
            url: "/api/bscUserInfoAgentSell/getAgentByNameFx?customerName="+query,
            method: 'post',
        });
    },
    selectAgentByNameFxOne(query,againstMode){
        return http({
            url: "/api/bscUserInfoAgentBasic/getAgentByNameFxOne?customerName="+query + "&againstMode=" + againstMode,
            method: 'post',
        });
    },
    getCityByArea(query){
        return http({
            url: "/api/bscUserInfoAgentSell/getCityByArea?areas="+query,
            method: 'post',
        });
    },
    getCityByAreaXsxz(query){
        return http({
            url: "/api/bscUserInfoAgentSell/getCityByAreaXsxz?areas="+query,
            method: 'post',
        });
    },
    selectUserNamesByAreaName(query){
        return http({
            url: "/api/swyl/v1/demo/bscUserDayCleanConfig/findUserNames?areaName="+query,
            method: 'get',
        });
    },
    selectUserloudNamesBydaquAndarea(query){
        return http({
            url: "/api/swyl/v1/demo/bscUserDayCleanConfig/getLoudUserNamesBydaquAndarea?areaName="+query,
            method: 'get',
        });
    },
    getNewLoudUserNamesByarea(query){
        return http({
            url: "/api/swyl/v1/demo/bscUserDayCleanConfig/getNewLoudUserNamesByarea",
            method: 'post',
            params: query
        });
    },
    selectUserNamesBydaquAndarea(query){
        return http({
            url: "/api/swyl/v1/demo/bscUserDayCleanConfig/UserNamesBydaquAndarea?areaName="+query,
            method: 'get',
        });
    },
    freezeOrThaw(query){
        return http({
            url: this.baseurl+'/freezeOrThaw',
            method: 'post',
            params: query
        });
    },
    getUserAuth(query){
        return http({
            url: this.baseurl+'/getUserAuth?code='+query,
            method: 'post',
        });
    },

}
